export enum PosthogTrackingEvents {
  ProtectionDetailsProtectionCtaClicked = 'protection-details-protection-cta-clicked',
  ProtectionDetailsRegisterOnlyCtaClicked = 'protection-details-register-only-cta-clicked',
}
